export default {"src":"/_next/static/media/logo-nudiva.10ce311f.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};